import { ViewConfig, Workbook } from "datasheets/model/core/Workbook";
import { ReactNode } from "react";

export interface ViewProps {
  testMode?: boolean;
  className?: string;
}

interface ViewDefinition {
  configGenerator: (viewName: string, workbook: Workbook) => ViewConfig;
  component: (props: ViewProps) => ReactNode;
}

class ViewFactoryType {
  map: {
    [viewType: string]: ViewDefinition;
  };
  constructor() {
    this.map = {};
  }
  addView(
    viewType: string,
    configGenerator: (viewName: string, workbook: Workbook) => ViewConfig,
    component: (props: ViewProps) => ReactNode
  ) {
    this.map[viewType] = { configGenerator: configGenerator, component };
  }
  _getView(viewType: string): ViewDefinition {
    if (viewType in this.map) {
      return this.map[viewType];
    } else {
      console.debug(Object.keys(this.map));
      throw new Error(
        "Unregistered view: " + viewType + " not in " + Object.keys(this.map)
      );
    }
  }
  generateConfig(
    viewType: string,
    viewName: string,
    workbook: Workbook
  ): ViewConfig {
    return this._getView(viewType).configGenerator(viewName, workbook);
  }
  component(viewType: string, props: ViewProps): ReactNode {
    return this._getView(viewType).component(props);
  }
  availableTypes(): string[] {
    return Object.keys(this.map);
  }
}
export const ViewFactory = new ViewFactoryType();
